import firebase from 'firebase/app'
import '@firebase/firestore'
import '@firebase/database'
    const config = {
        apiKey: "AIzaSyCW_JNM2vtxvReJ4SLglbFPmILANGmADhg",
        authDomain: "tech-institute.firebaseapp.com",
        projectId: "tech-institute",
        storageBucket: "tech-institute.appspot.com",
        messagingSenderId: "902915363854",
        appId: "1:902915363854:web:e3803939f905925be3985f",
        measurementId: "G-CMR17YFPVN"
    }

    firebase.initializeApp(config)

    export const firestore = firebase.firestore()
    export const db = firebase.database()
export default firebase